import { CarrierDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { createPath, Paths } from '../../../../app/router/app.router';
import { CarrierDetailsPageHeaderProps } from '../../../../ui/components/pure/page-headers/details/carrier-details/carrier-details-page-header.component';
import { mapTransactionTypesToIcons } from '../../../deliveries/maps/kiosk-transaction-types-to-icons.map';
import { CarrierDetailsActions, makeDefineCarrierDetailsActions } from '../actions/carrier-details.actions';
import { NEEDS_REVIEW_LABEL, NEEDS_REVIEW_TOOLTIP, needsReview } from '../../logic/carrier-review';
import { carrierAuthorisingProjectID } from '../../logic/carrier-management';

export function makeCarrierDetailsHeaderProps(
  carrier: CarrierDto,
  projectID: string,
  setAction: (action: CarrierDetailsActions | null) => void,
  shortcode?: string
): CarrierDetailsPageHeaderProps {
  return {
    name: carrier.name,
    shortName: carrier.shortName,
    image: carrier.image,
    status: carrier.status,
    review: needsReview(carrier) ? { label: NEEDS_REVIEW_LABEL, tooltip: NEEDS_REVIEW_TOOLTIP } : undefined,
    container: carrier.container
      ? {
          name: carrier.container.name,
          projectName: carrier.container.project?.name,
          // The viewer's project, not the container's — they may not be able to read that one.
          url: createPath(Paths.carriers, { projectID: shortcode || projectID })
        }
      : undefined,
    kioskRegistrationPolicy: carrier.kioskRegistrationPolicy,
    qrRegistrationPolicy: carrier.qrRegistrationPolicy,
    capabilities: mapTransactionTypesToIcons(carrier.capabilities || []),
    actions: makeDefineCarrierDetailsActions(carrier, carrierAuthorisingProjectID(carrier, projectID))(setAction)
  };
}
